import icomoonttf from '../../assets/fonts/icomoon/icomoon.ttf';
import icomoonwoff from '../../assets/fonts/icomoon/icomoon.woff';
import icomoonsvg from '../../assets/fonts/icomoon/icomoon.svg';
import icomooneot from '../../assets/fonts/icomoon/icomoon.eot';

/**
 * Removed default values on .icon-logo path 1, 3 and 4 to avoid hierarchy
 * selector issues, the color may not be visible at icomoon 🥟
 * Note: Do not edit this constant unless you know what you're doing.
 */
const logoStyles = `
  .icon-logo .path1:before {
    content: "\\e904";
    color: inherit;
  }
  .icon-logo .path2:before {
    content: "\\e905";
    margin-left: -1.974609375em;
    color: rgb(206, 24, 30);
  }
  .icon-logo .path3:before {
    content: "\\e906";
    margin-left: -1.974609375em;
    color: inherit;
  }
  .icon-logo .path4:before {
    content: "\\e907";
    margin-left: -1.974609375em;
    color: inherit;
  }
`;

/**
 * iconStyles is used to add new icons from icomoon generator,
 * this new icons must be added at the beginning.
 * Notes:
 * 1. Do not add logo styles.
 * 2. Make sure you add double back slash in the content property `content: '\\...'`
 */
const iconStyles = `
  .icon-all-locations:before {
    content: "\\e91f";
  }
  .icon-location:before {
    content: "\\e923";
  }
  .icon-map:before {
    content: "\\e924";
  }
  .icon-refresh:before {
    content: "\\e91e";
  }
  .icon-success .path1:before {
    content: "\\e918";
    color: rgb(57, 57, 57);
  }
  .icon-success .path2:before {
    content: "\\e919";
    margin-left: -1em;
    color: rgb(57, 57, 57);
  }
  .icon-success .path3:before {
    content: "\\e91a";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-error .path1:before {
    content: "\\e91b";
    color: rgb(57, 57, 57);
  }
  .icon-error .path2:before {
    content: "\\e91c";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-error .path3:before {
    content: "\\e91d";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-filters:before {
    content: "\\e917";
  }
  .icon-checkmark:before {
    content: "\\e915";
  }
  .icon-chevron:before {
    content: "\\e916";
  }
  .icon-facebook:before {
    content: "\\e909";
  }
  .icon-linkedin:before {
    content: "\\e90a";
  }
  .icon-twitter:before {
    content: "\\e90b";
  }
  .icon-closer:before {
    content: "\\e908";
  }
  .icon-external:before {
    content: "\\e914";
  }
  .icon-pin:before {
    content: "\\e911";
  }
  .icon-arrow-previous:before {
    content: "\\e912";
  }
  .icon-arrow-next:before {
    content: "\\e913";
  }
  .icon-light_rail_station:before {
    content: "\\e90c";
  }
  .icon-bus_station:before {
    content: "\\e90d";
  }
  .icon-subway_station:before {
    content: "\\e90e";
  }
  .icon-train_station:before {
    content: "\\e90f";
  }
  .icon-transit_station:before {
    content: "\\e910";
  }
  .icon-search:before {
    content: "\\e903";
  }
  .icon-profile:before {
    content: "\\e900";
  }
  .icon-menu:before {
    content: "\\e901";
  }
  .icon-phone:before {
    content: "\\e902";
  }
`;

export default `
  @font-face {
    font-family: 'icomoon';
    src:  url('${icomooneot}');
    src:  url('${icomooneot}') format('embedded-opentype'),
      url('${icomoonttf}') format('truetype'),
      url('${icomoonwoff}') format('woff'),
      url('${icomoonsvg}') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
  }
  ${iconStyles}
  ${logoStyles}
`;
